import { useMemo } from "react";
import { useLocation } from "react-router";

// Returns location.state, keeping a per-path copy in sessionStorage so the
// page still has its state after a browser refresh.
const usePersistedLocationState = () => {
  const location = useLocation();
  const storageKey = `locationState:${location.pathname}`;

  return useMemo(() => {
    try {
      if (location.state) {
        sessionStorage.setItem(storageKey, JSON.stringify(location.state));
        return location.state;
      }
      return JSON.parse(sessionStorage.getItem(storageKey));
    } catch {
      return location.state || null;
    }
  }, [location.state, storageKey]);
};

export default usePersistedLocationState;
